/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.assetLibraryModule')
  .service('BulbAssetLibraryUploadService', ['$cookies', '$window', 'BulbAssetLibraryService', 'BulbAuthService',
    'BulbBusyCoverService', 'UploadAssetService', 'ASSET_LIBRARY',
    BulbAssetLibraryUploadService]);

function BulbAssetLibraryUploadService(
  $cookies,
  $window,
  BulbAssetLibraryService,
  BulbAuthService,
  BulbBusyCoverService,
  UploadAssetService,
  ASSET_LIBRARY,
) {

  const that = this;
  const maxFileSize = 10000000000;
  const acceptAudioFileTypes = /(\.|\/)(mp3|wav|m4a)$/i;
  const acceptImageFileTypes = /(\.|\/)(gif|jpe?g|png|tiff?|pnm|pcx|sgi|bmp|webp|heic)$/i;
  const acceptVideoFileTypes = /(\.|\/)(3g2|3gp|asf|avi|flv|m4v|mkv|mov|mp4|mpg|vob|wmv|quicktime)$/i;

  this.fileUploadOptions = {
    paramName: 'files[]',
    maxChunkSize: 5242880, // TODO CLEAN: need to get this from CONFIG after merge with dev
    maxFileSize, // TODO CLEAN: need to get this from CONFIG after merge with dev
    headers: {
      'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN'),
    },
    dataType: 'json',
    sequentialUploads: true,
  };

  const createUrl = function (entry) {
    return `/b/rest/assetlibrary/${entry.id}/upload`;
  };

  this.checkImageFileName = function (fileName) {
    return fileName.match(acceptImageFileTypes);
  };

  this.checkVideoFileName = function (fileName) {
    return fileName.match(acceptVideoFileTypes);
  };

  this.checkAudioFileName = function (fileName) {
    return fileName.match(acceptAudioFileTypes);
  };

  const submitProcess = function (data) {
    const chunks = Math.ceil(data.files[0].size / that.fileUploadOptions.maxChunkSize);
    let chunk = 0;
    data.formData = function () {
      const formData = [{
        name: 'entryId',
        value: data.entry.id,
      }, {
        name: 'folderId',
        value: data.folderId,
      }, {
        name: 'chunks',
        value: chunks,
      }, {
        name: 'chunk',
        value: chunk,
      }];

      chunk++;
      return formData;
    };
  };

  const addProgressHandler = function (handlerObj, progressHandlerName, options) {
    // Only add progress callbacks for browsers that support XHR2, and
    // test for XHR2 per:
    //
    // http://stackoverflow.com/questions/6767887/what-is-the-best-way-to-check-for-xhr2-file-upload-support
    if (new XMLHttpRequest().upload) {
      options.progress = function (e, data) {
        const progress = parseInt(data.loaded / data.total * 100, 10);
        $.proxy(handlerObj, progressHandlerName, e, data, progress)();
      };
    }
  };

  // check file size
  const checkUploadFileSize = function (file) {
    return file.size <= maxFileSize;
  };

  // check the used storage size
  const checkStorageUsed = function (file) {
    const storage = BulbAuthService.currentUser.features.StorageFeature;

    if (storage.maxStorageBytes < 0) {
      return true;
    }

    return storage.currentUsedStorageBytes + file.size <= storage.maxStorageBytes;
  };

  const validateFileAndStorageSize = function (file) {
    if (!checkUploadFileSize(file)) {
      BulbAssetLibraryService.dialog.showFileSizeExceedError();
      return false;
    }

    // check the used storage size
    if (!checkStorageUsed(file)) {
      BulbAssetLibraryService.dialog.showStorageSizeExceedError();
      return false;
    }
    return true;
  };

  const abortUploadingWhenMultipleFiles = function (e, data) {
    if (data.files.length > 1) {
      data.abortUploading = true;
      BulbAssetLibraryService.dialog.showMessage({}, 'assetlibrary_multiple_file_upload_error');
    }
  };

  // image upload options
  this.createImageUploadOptions = function (
    getFolderIdFn,
    handlerObj,
    addHandlerName,
    submitHandlerName,
    progressHandlerName,
    doneHandlerName,
    deleteOnEnd,
    multipleFiles,
  ) {
    const options = angular.merge({}, {

      acceptFileTypes: acceptImageFileTypes,
      add(e, data) {

        if (data.abortUploading) {
          return;
        }

        const file = data.files[0];
        const entry = {
          name: file.name,
          credit: '',
          fileSize: file.size,
        };

        if (!that.checkImageFileName(file.name)) {
          // We have a 'special' alert for images that are the .heic file extension:
          if (file.name.split('.').pop().toLowerCase() === 'heic') {
            BulbAssetLibraryService.dialog.showImageHEICUnsupportedError();
            return;
          }
          if (data.unsupportedFileFormatErrorVisible !== false) {
            BulbAssetLibraryService.dialog.showUnsupportedFileFormatError();
          }
          return;
        }

        // check the upload file size and the storage size
        if (!validateFileAndStorageSize(file)) {
          return;
        }

        BulbBusyCoverService.showBusyDuring(
          BulbAssetLibraryService.api.createImage(getFolderIdFn ? getFolderIdFn() : null, entry)
            .then((res) => {
              data.entry = res.entry;
              data.url = createUrl(res.entry);

              if (addHandlerName) {
                $.proxy(handlerObj, addHandlerName, e, data)();
              }

              data.process().done(() => {
                const reader = new FileReader();
                reader.onload = function (event) {
                  data.target = event.target;
                  data.submit();
                };
                reader.readAsDataURL(data.files[0]);
              });
            }),
        );
      },

      submit(e, data) {
        submitProcess(data);
        if (submitHandlerName) {
          $.proxy(handlerObj, submitHandlerName, e, data)();
        }
      },

      done(e, data) {
        if (doneHandlerName) {
          $.proxy(handlerObj, doneHandlerName, e, data)();
        }
        if (deleteOnEnd) {
          $(e.target).remove();
        }
      },

    }, this.fileUploadOptions);

    if (!multipleFiles) {
      options.drop = abortUploadingWhenMultipleFiles;
    }

    if (progressHandlerName) {
      addProgressHandler(handlerObj, progressHandlerName, options);
    }

    return options;
  };

  // video upload options
  this.createVideoUploadOptions = function (
    getFolderIdFn,
    handlerObj,
    addHandlerName,
    submitHandlerName,
    progressHandlerName,
    doneHandlerName,
    deleteOnEnd,
    multipleFiles,
  ) {

    const options = angular.merge({}, {

      acceptFileTypes: acceptVideoFileTypes,
      add(e, data) {

        if (data.abortUploading) {
          return;
        }

        const file = data.files[0];
        const entry = {
          name: file.name,
          credit: '',
          fileSize: file.size,
        };

        if (!that.checkVideoFileName(file.name)) {
          if (data.unsupportedFileFormatErrorVisible !== false) {
            BulbAssetLibraryService.dialog.showUnsupportedFileFormatError();
          }
          return;
        }

        // check the upload file size and the storage size
        if (!validateFileAndStorageSize(file)) {
          return;
        }

        BulbBusyCoverService.showBusyDuring(
          BulbAssetLibraryService.api.createVideo(getFolderIdFn ? getFolderIdFn() : null, entry)
            .then((res) => {
              data.entry = res.entry;
              data.url = createUrl(res.entry);

              if (addHandlerName) {
                $.proxy(handlerObj, addHandlerName, e, data)();
              }

              data.process().done(() => {
                const reader = new FileReader();
                reader.onload = function (event) {
                  data.submit();
                };
                reader.readAsDataURL(data.files[0]);
              });
            }),
        );
      },

      submit(e, data) {
        submitProcess(data);
        if (submitHandlerName) {
          $.proxy(handlerObj, submitHandlerName, e, data)();
        }
      },

      done(e, data) {
        if (doneHandlerName) {
          $.proxy(handlerObj, doneHandlerName, e, data)();
        }
        if (deleteOnEnd) {
          $(e.target).remove();
        }
      },

    }, this.fileUploadOptions);

    if (!multipleFiles) {
      options.drop = abortUploadingWhenMultipleFiles;
    }

    if (progressHandlerName) {
      addProgressHandler(handlerObj, progressHandlerName, options);
    }

    return options;
  };

  // attached file upload options
  this.createAttachedFileUploadOptions = function (
    getFolderIdFn,
    handlerObj,
    addHandlerName,
    submitHandlerName,
    progressHandlerName,
    doneHandlerName,
    deleteOnEnd,
    multipleFiles,
  ) {

    const options = angular.merge({}, {

      add(e, data) {

        if (data.abortUploading) {
          return;
        }

        if (!BulbAuthService.currentUser.features.AddFileFeature.enabled) {
          BulbAssetLibraryService.dialog.showUnauthorizedError();
          return;
        }

        const file = data.files[0];
        const entry = {
          name: file.name,
          credit: '',
          fileSize: file.size,
        };

        // check the upload file size and the storage size
        if (!validateFileAndStorageSize(file)) {
          return;
        }

        BulbBusyCoverService.showBusyDuring(
          BulbAssetLibraryService.api.createAttachedFile(getFolderIdFn ? getFolderIdFn() : null, entry)
            .then((res) => {
              data.entry = res.entry;
              data.url = createUrl(res.entry);

              if (addHandlerName) {
                $.proxy(handlerObj, addHandlerName, e, data)();
              }

              data.process().done(() => {
                const reader = new FileReader();
                reader.onload = function (event) {
                  data.submit();
                };
                reader.readAsDataURL(data.files[0]);
              });
            }),
        );
      },

      submit(e, data) {
        submitProcess(data);
        if (submitHandlerName) {
          $.proxy(handlerObj, submitHandlerName, e, data)();
        }
      },

      done(e, data) {
        if (doneHandlerName) {
          $.proxy(handlerObj, doneHandlerName, e, data)();
        }
        if (deleteOnEnd) {
          $(e.target).remove();
        }
      },

    }, this.fileUploadOptions);

    if (!multipleFiles) {
      options.drop = abortUploadingWhenMultipleFiles;
    }

    if (progressHandlerName) {
      addProgressHandler(handlerObj, progressHandlerName, options);
    }

    return options;
  };

  // audio file upload options
  this.createAudioUploadOptions = function (
    getFolderIdFn,
    handlerObj,
    addHandlerName,
    submitHandlerName,
    progressHandlerName,
    doneHandlerName,
    deleteOnEnd,
    multipleFiles,
  ) {

    const options = angular.merge({}, {

      acceptFileTypes: acceptAudioFileTypes,
      add(e, data) {

        if (data.abortUploading) {
          return;
        }

        const file = data.files[0];
        const entry = {
          name: file.name,
          credit: '',
          fileSize: file.size,
        };

        if (!that.checkAudioFileName(file.name)) {
          if (data.unsupportedFileFormatErrorVisible !== false) {
            BulbAssetLibraryService.dialog.showUnsupportedFileFormatError();
          }
          return;
        }

        // check the upload file size and the storage size
        if (!validateFileAndStorageSize(file)) {
          return;
        }

        BulbBusyCoverService.showBusyDuring(
          BulbAssetLibraryService.api.createAudio(getFolderIdFn ? getFolderIdFn() : null, entry)
            .then((res) => {
              data.entry = res.entry;
              data.url = createUrl(res.entry);

              if (addHandlerName) {
                $.proxy(handlerObj, addHandlerName, e, data)();
              }

              data.process().done(() => {
                const reader = new FileReader();
                reader.onload = function (event) {
                  data.submit();
                };
                reader.readAsDataURL(data.files[0]);
              });
            }),
        );
      },

      submit(e, data) {
        submitProcess(data);
        if (submitHandlerName) {
          $.proxy(handlerObj, submitHandlerName, e, data)();
        }
      },

      done(e, data) {
        if (doneHandlerName) {
          $.proxy(handlerObj, doneHandlerName, e, data)();
        }
        if (deleteOnEnd) {
          $(e.target).remove();
        }
      },

    }, this.fileUploadOptions);

    if (!multipleFiles) {
      options.drop = abortUploadingWhenMultipleFiles;
    }

    if (progressHandlerName) {
      addProgressHandler(handlerObj, progressHandlerName, options);
    }

    return options;
  };

  this.createInputFileElement = function (multiple) {
    return multiple ? '<input type="file" multiple>' : '<input type="file">';
  };

  /**
   * Upload a selected file.
   *
   * FUTURE CLEAN : most of the parameters are outdated, since we are using Uppy.
   *
   * @param uploadOptions Upload configuration options.
   * @param typeFilter File type filter on allowed file types.
   * @param multiple If the user is upload multiple files.
   * @param fromWithinAssetLibrary If the user is uploading a file from within the assetlibrary or not.
   * @param uploadSate Current upload workflow state initiated by the user.
   */
  this.uploadFile = function (uploadOptions, typeFilter, multiple, fromWithinAssetLibrary, uploadSate) {
    const $file = $(that.createInputFileElement(multiple));
    $file.attr('accept', typeFilter);
    $file.addClass('hiddenUploader');
    $('body').append($file);

    // Direct to S3 Upload:
    UploadAssetService.uploadFile($file, typeFilter, fromWithinAssetLibrary, uploadSate);
  };

  /**
   * Global event listener for initialization for drag and drop with the new upload workflow.
   *
   * FUTURE CLEAN : Not happy with this 'implementation' of the drag and drop with our new upload workflow however
   * due to the current timeline and the push to get this out, it will have to due.
   *
   * Ideally, I would absolutely love to use Uppy's Drag & Drop plugin. I would have to come back and
   * implement that later.
   * ^^ https://bulbapp.atlassian.net/browse/BULBAPP-1273
   */
  $window.addEventListener('initDragAndDrop', (data) => {
    const { file } = data.detail;
    const allowedTypes = data.detail.attr;
    const { fromWithinAssetLibrary } = data.detail;
    const { uploadState } = data.detail;

    // Close the current selection modal as soon as drop action is completed.
    BulbAssetLibraryService.dialog.closeCurrentModal();

    // Direct to S3 Upload the dropped file
    UploadAssetService.uploadFileWithoutBrowser(file, allowedTypes, fromWithinAssetLibrary, uploadState);
  });

  // upload image by selection modal
  this.uploadImageBySelectionModal = function (
    handlerObj,
    addHandlerName,
    submitHandlerName,
    progressHandlerName,
    doneHandlerName,
    fromWithinAssetLibrary,
    uploadSate,
  ) {
    const options = this.createImageUploadOptions(
      null,
      handlerObj,
      addHandlerName,
      submitHandlerName,
      progressHandlerName,
      doneHandlerName,
      false,
    );
    this.uploadFile(options, ASSET_LIBRARY.FILTER.IMAGE, false, fromWithinAssetLibrary, uploadSate);
  };

  // upload video by selection modal
  this.uploadVideoBySelectionModal = function (
    handlerObj,
    addHandlerName,
    submitHandlerName,
    progressHandlerName,
    doneHandlerName,
    fromWithinAssetLibrary,
    uploadSate,
  ) {
    const options = this.createVideoUploadOptions(
      null,
      handlerObj,
      addHandlerName,
      submitHandlerName,
      progressHandlerName,
      doneHandlerName,
      false,
    );
    this.uploadFile(options, ASSET_LIBRARY.FILTER.VIDEO, false, fromWithinAssetLibrary, uploadSate);
  };

  // upload attached file by selection modal
  this.uploadAttachedFileBySelectionModal = function (
    handlerObj,
    addHandlerName,
    submitHandlerName,
    progressHandlerName,
    doneHandlerName,
    fromWithinAssetLibrary,
    uploadSate,
  ) {
    const options = this.createAttachedFileUploadOptions(
      null,
      handlerObj,
      addHandlerName,
      submitHandlerName,
      progressHandlerName,
      doneHandlerName,
      false,
    );
    this.uploadFile(options, ASSET_LIBRARY.FILTER.ATTACHED_FILE, false, fromWithinAssetLibrary, uploadSate);
  };

  // upload audio file by selection modal
  this.uploadAudioBySelectionModal = function (
    handlerObj,
    addHandlerName,
    submitHandlerName,
    progressHandlerName,
    doneHandlerName,
    fromWithinAssetLibrary,
    uploadSate,
  ) {
    const options = this.createAudioUploadOptions(
      null,
      handlerObj,
      addHandlerName,
      submitHandlerName,
      progressHandlerName,
      doneHandlerName,
      false,
    );
    this.uploadFile(options, ASSET_LIBRARY.FILTER.AUDIO, false, fromWithinAssetLibrary, uploadSate);
  };

}
